export default {
  data() {
    return {
      _widgetId: null,
      _tokenResolver: null,
      turnstileNeedsInteraction: false,
    }
  },

  mounted() {
    const init = () => {
      const el = this.$refs.turnstileWidget
      if (!el) return
      this._widgetId = window.turnstile.render(el, {
        sitekey: window.TURNSTILE_SITE_KEY || '',
        appearance: 'always',
        execution: 'execute',
        callback: token => {
          if (this._tokenResolver) { this._tokenResolver(token); this._tokenResolver = null }
        },
        'error-callback': () => {
          if (this._tokenResolver) { this._tokenResolver(''); this._tokenResolver = null }
        },
        'expired-callback': () => {
          if (this._widgetId !== null && window.turnstile) {
            window.turnstile.reset(this._widgetId)
          }
        },
      })
    }
    if (window.turnstile) {
      this.$nextTick(init)
    } else {
      document.addEventListener('turnstile-ready', () => this.$nextTick(init), { once: true })
    }
  },

  beforeDestroy() {
    if (this._widgetId !== null && window.turnstile) {
      window.turnstile.remove(this._widgetId)
      this._widgetId = null
    }
  },

  methods: {
    _getTurnstileToken() {
      if (!window.turnstile) return Promise.resolve('')
      if (this._widgetId === null) return Promise.resolve('')

      return new Promise(resolve => {
        this._tokenResolver = resolve

        try {
          window.turnstile.reset(this._widgetId)
          window.turnstile.execute(this._widgetId)
        } catch (e) {
          if (this._tokenResolver) { this._tokenResolver(''); this._tokenResolver = null }
        }
      })
    },
  },
}
